module.exports = __webpack_public_path__ + "static/img/irole.240a9bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/xk/irole.png
// module id = e5GS
// module chunks = 7